import moment from 'moment';

export const requestStartPassed = (date: string | Date, startTime: string | Date) => {
	const startTimeDate = new Date(startTime);
	const startDate = moment(new Date(date)).set({ hour: startTimeDate.getHours(), minute: startTimeDate.getMinutes() });
	const now = new Date();
	return startDate.isBefore(now);
}